import { Component, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { DetailStoreService } from 'src/app/itineries/services/store/detail-store/detail-store.service';
import { DriversStoreService } from 'src/app/itineries/services/store/drivers-store/drivers-store.service';
import { FleetStoreService } from 'src/app/itineries/services/store/fleet-store/fleet-store.service';
import { FundingsourcestoreService } from 'src/app/itineries/services/store/fundingsource-store/fundingsource-store.service';
import { LosStoreService } from 'src/app/itineries/services/store/los-store/los-store.service';
import { ServiceareaStoreService } from 'src/app/itineries/services/store/servicearea-store/servicearea-store.service';
import { SpaceTypeStoreService } from 'src/app/itineries/services/store/spacetype-store/spacetype-store.service';
import { TripStoreService } from 'src/app/itineries/services/store/trip-store/trip-store.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as _ from 'underscore';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { SearchStoreService } from 'src/app/itineries/services/store/search-store/search-store.service';



@Component({
  selector: 'app-tripsheet',
  templateUrl: './tripsheet.component.html',
  styleUrls: ['./tripsheet.component.css']
})
export class TripsheetComponent implements OnInit {

  trips = [];
  driverList = []
  serviceAreaList = []
  corporateList = []
  levelOfServiceList = []
  preDriverList;
  fleetList = []
  spaceTypeList = []
  driverTrips={};
  user;
  timeZone;
  todayDate;
  selectedTrip;
  selectedDriver;
  preServiceAreas = {};
  preSpaceTypes = {};
  driverShift = false;


  constructor(
    private tripStore: TripStoreService,
    private driverStore: DriversStoreService,
    private sharedDataService: SharedDataService,
    private fundingSourceStore: FundingsourcestoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private serviceAreasStore: ServiceareaStoreService,
    private losStore: LosStoreService,
    private fleetStore: FleetStoreService,
    private detailStore: DetailStoreService,
    private assignTripService: AssigTripsService,
    private searchStore: SearchStoreService
  ) { }


  ngOnInit() {
    this.getUser()
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data
          this.timeZone = data.timeZone;
          this.prepareData();
        }
      });
  }

  prepareData() {
          this.getDriverList();
          this.getServiceAreas();
          this.getCorporate();
          this.getLevelOfService();
          this.getFleetList();
          this.getSpaceTypes();
          this.getTrips();
  }

  getSearchData() {
    this.searchStore.state$.subscribe((data: any) => {
      if (data) {
        this.todayDate = data.date;
      }
    })
  }

  getDriverList() {
    this.driverStore.state$.subscribe((data) => {
      if (data) {
        this.driverList = data.list;
        this.preDriverList = data.map;
      }
    })
  }

  getServiceAreas() {
    this.serviceAreasStore.state$.subscribe((data) => {
      if (data) {
        this.serviceAreaList = data.list;
        this.preServiceAreas = data.map;
      }
    })
  }

  getCorporate() {
    this.fundingSourceStore.state$.subscribe((data) => {
      if (data) {
        this.corporateList = data.list;
      }
    })
  }

  getLevelOfService() {
    this.losStore.state$.subscribe((data) => {
      if (data) {
        this.levelOfServiceList = data.list;
      }
    })
  }

  getFleetList() {
    this.fleetStore.state$.subscribe((data) => {
      if (data) {
        this.fleetList = data.list;
      }
    })
  }

  getSpaceTypes() {
    this.spaceTypeStore.state$.subscribe((data) => {
      if (data) {
        this.spaceTypeList = data.list;
        this.preSpaceTypes = data.map;
      }
    })
  }

  getTrips() {
    this.tripStore.state$.subscribe((data) => {
      if (data) {
        this.trips = data.list;
        const groupedTrips = _.groupBy(
          this.trips,
          trip => {
            if (trip.driver && typeof trip.driver === 'object' && trip.driver._id) {
              return trip.driver._id;
            } else if (trip.driver && typeof trip.driver === 'string') {
              return trip.driver;
            } else {
              return 'no_driver';
            }
          }
        );

        this.driverList.forEach(driver => {
          const trips = groupedTrips[driver._id];
          if (trips && trips.length) {
            this.driverTrips[driver._id] = trips;
          }
        });

        if (groupedTrips['no_driver']) {
          this.driverTrips['no_driver'] = groupedTrips['no_driver'];
        }
      }
    });
  }

  getStartPoint(date, b) {
    let startinghoursPoint = moment(date).tz(this.timeZone).hours() * 12;

    if (startinghoursPoint < 1) {
      startinghoursPoint = 1
    }

    if (b && startinghoursPoint < 1) {
      startinghoursPoint = 1;
    }

    const startingMinutesPoint = this.calculateMinutesValue(moment(date).tz(this.timeZone).minutes());
    return startinghoursPoint + startingMinutesPoint;

  }

  getEndPoint(dateOne, dateTwo) {
    // Define the two times
    const time1 = moment(dateOne).tz(this.timeZone);
    const time2 = moment(dateTwo).tz(this.timeZone);

    // Calculate the difference in minutes
    let diffInMinutes = time2.diff(time1, 'minutes');

    // Ensure the minimum value is 1 minute
    if (diffInMinutes < 1) {
      diffInMinutes = 1;
    }

    // Convert the difference to hours and minutes
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    let res = this.getStartPoint(moment(`${hours}:${minutes.toString().padStart(2, '0')}`, 'HH:mm').toISOString(), false);

    if (time1.hours() < 1) {
      res -= 1;
    }

    return res;
  }

  getNumberOfDrivers() {
    return Object.keys(this.driverTrips).length;
  }


  calculateMinutesValue(value) {
    return Math.round(((value * 12) / 60));
  }

  filterDetails(trip) {
    if (trip) {
      this.detailStore.setEntitiesNew(trip);
    }
  }

  ngOnDestroy(): void {
  }

  getConnectedZoneIds(currentZoneId: string): string[] {
    const filtered = Object.keys(this.driverTrips).filter(key => key !== currentZoneId)
    return filtered;

  }

  onDrop(event: CdkDragDrop<string[]>, zoneId: string) {
    const targetDriver = this.preDriverList[zoneId];
    const alertMessage = this.getAlertMessage(zoneId, targetDriver);

    const from = event.previousContainer.data;
    const to = event.container.data;
    const trip: any = from[event.previousIndex];

    if (trip && trip.farmout) return;
    if (to === from) return;

    sweetAlert('Alert', alertMessage, 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {

          if (event.previousContainer === event.container) {
            moveItemInArray(to, event.previousIndex, event.currentIndex);
          } else {
            transferArrayItem(from, to, event.previousIndex, event.currentIndex);
          }

          this.selectedTrip = trip;
          // Check if unassigning
          if (zoneId === 'no_driver') {
            this.unAssignTrip();
          } else {
            this.selectedDriver = targetDriver;
            this.assignTrip();
          }

        }
      });
  }
  assignTrip() {
    this.selectedTrip.driver = this.selectedDriver._id;
    this.selectedTrip.status = 'offered';
    this.selectedTrip.jobStatus = 'offered';
    this.assignSingleTrip(this.selectedTrip);
  }

  getAlertMessage(zoneId: string, targetDriver: any): string {
    return zoneId === 'no_driver'
      ? 'Are you sure you want to unassign this trip?'
      : `Are you sure you want to assign this trip to ${targetDriver.displayName}?`;
  }

  assignSingleTrip(payload) {

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.selectedTrip = null;
          const findTripIndex = this.trips.findIndex(t => t._id === payload._id);
          if (findTripIndex >= 0) {
            this.trips[findTripIndex] = data;
          } else {
            this.trips.push(data);
          }
          this.tripStore.setEntities(this.trips);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  unAssignTrip() {
    this.selectedTrip.jobStatus = 'pending';
    this.selectedTrip.status = 'unassigned';
    this.updateSingleTrip(this.selectedTrip);
  }


  updateSingleTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.selectedTrip = null;
          const findTripIndex = this.trips.findIndex(t => t._id === payload._id);
          if (findTripIndex >= 0) {
            this.trips[findTripIndex] = data;
          } else {
            this.trips.push(data);
          }
          this.tripStore.setEntities(this.trips);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  isDisabledDrag(trip) {
    return !['offered', 'accepted', 'unassigned'].includes(trip.status) || !!trip.farmout;
  }

  currentDayShift(shifts) {
    const currentDay = moment(this.todayDate).tz(this.timeZone).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  getShiftStartPoint(date, b) {
    const modifiedDate = moment(date, 'HH:mm').toISOString();
    let startinghoursPoint = moment(modifiedDate).tz(this.timeZone).hours() * 12;

    if (startinghoursPoint < 1) {
      startinghoursPoint = 1
    }

    if (b && startinghoursPoint < 1) {
      startinghoursPoint = 1;
    }

    const startingMinutesPoint = this.calculateMinutesValue(moment(modifiedDate).tz(this.timeZone).minutes());
    return startinghoursPoint + startingMinutesPoint;

  }


  getShiftEndPoint(dateOne, dateTwo) {
    // Define the two times
    const modifiedDate1 = moment(dateOne, 'HH:mm').toISOString();
    const modifiedDate2 = moment(dateTwo, 'HH:mm').toISOString();

    const time1 = moment(modifiedDate1).tz(this.timeZone);
    const time2 = moment(modifiedDate2).tz(this.timeZone);

    // Calculate the difference in minutes
    let diffInMinutes = time2.diff(time1, 'minutes');

    // Ensure the minimum value is 1 minute
    if (diffInMinutes < 1) {
      diffInMinutes = 1;
    }

    // Convert the difference to hours and minutes
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    let res = this.getStartPoint(moment(`${hours}:${minutes.toString().padStart(2, '0')}`, 'HH:mm').toISOString(), false);

    if (time1.hours() < 1) {
      res -= 1;
    }
    return res;
  }

    clockTime() {
      return moment().tz(this.timeZone).toISOString();
    }


  sortMethod() {
    return 0;
  }

}


